import { render, staticRenderFns } from "./FactorTransactionList.vue?vue&type=template&id=406bcf79&scoped=true&"
import script from "./FactorTransactionList.vue?vue&type=script&lang=js&"
export * from "./FactorTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406bcf79",
  null
  
)

export default component.exports